export const PIXELS_PER_METER = 7.5;
export const PLAYER_SCREEN_RATIO = 0.35;
export const COLORS = {
  blueSuit: 0x1d5b85,
  glacierShadow: 0xc3dadc,
  ink: 0x102933,
  powder: 0xf7f9f5,
  redHelmet: 0xe84d2a,
  signal: 0xe84d2a,
  skiYellow: 0xf5c844,
  spruce: 0x174f45,
  stone: 0x71858a,
  white: 0xffffff,
} as const;
